import React from 'react';

import List from './parts/list.js';
import { Resizable } from "re-resizable";
import './servers.scss';

const ServersPanel = () => {
  	const [height, setHeight] = React.useState(300);
	return (
		<Resizable 
			className='servers__wrapper'
			size={{ height }}
			enable={{bottom: true}} 
			onResizeStop={(e, direction, ref, d) => {
				setHeight(height + d.height);
		  	}}>
			<div className="servers">
				<List />
			</div>
		</Resizable>
	);
};

export default ServersPanel;